import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import { green } from '@material-ui/core/colors';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { fetchDefault } from './Utils.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';
import Cookies from 'js-cookie';



const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(0.5),
        },
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
    },
       
    menuButton: {
        margin: theme.spacing(0.5),
        fontSize: 15,
    },

    
    membershipAbsolute: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },

    paper: {
        padding: theme.spacing(1, 1),
        marginTop: 0,
        marginBottom: 10,
    },

    cabinetPaper: {
        padding: theme.spacing(1, 1),
        marginTop: 0,
        marginBottom: 10,
    },

    noticeButton: {
        background: "white",
        marginLeft: 5, 
        fontSize: 11
    },

    DateTextField: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 220,
    },
    currentPrepaidTime: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 130,
    },

}));

export default function Home(props) {
    const classes = useStyles();
    let history = useHistory();

    const [state, setState] = React.useState({ open: false });

    //const [tableName, setTableName] = React.useState();
    //const [endTime, setEndTime] = React.useState();
    //const [useTimeMin, setUseTimeMin] = React.useState();
    const [useTableList, setUseTableList] = React.useState();

    const [seatMap, setSeatMap] = React.useState(false);
    const [wifi, setWifi] = React.useState(false);
    const [restroom, setRestroom] = React.useState(false);
    const [contact, setContact] = React.useState(false);
    const [refund, setRefund] = React.useState(false);

    const [selectedReservationId, setSelectedReservationId] = React.useState("");
    const [leaving, setLeaving] = React.useState(false);
    const [cancelReserveDialog, setCancelReserveDialog] = React.useState(false);
    const [cancelReserveId, setCancelReserveId] = React.useState();

    const [refundMoney, setRefundMoney] = React.useState(false);
    const [refundTime, setRefundTime] = React.useState(false);

    const [reserveList, setReserveList] = React.useState();

    const { open } = state;
    const [clickCount, setClickCount] = useState(0);

    //const [cabinetNumber, setCabinetNumber] = React.useState();
    //const [cabinetEndTime, setCabinetEndTime] = React.useState();
    //const [cabinetPassword, setCabinetPassword] = React.useState();
    const [useCabinetList, setUseCabinetList] = React.useState();

    const [myMoney, setMyMoney] = React.useState();
    const [myPrepaid, setPrepaid] = React.useState();
    const [currentMonthly, setCurrentMonthly] = React.useState();
    const [monthlyList, setMonthlyList] = React.useState();

    const handleClick = () => {
        setState({ open: true });
    };

    const handleClose = () => {
        setState({ open: false });
    };

    const leavingOpen = (reservationId) => {
        fetchDefault('/Seat/GetLeavingSeatRefundMoney?reservationId=' + reservationId,
            (data) => {
                setRefundMoney(data.refundMoney);
                setRefundTime(data.refundTime);
                setLeaving(true);
                setSelectedReservationId(reservationId);
            }
        );
    };

    const leavingSeat = () => {
        fetchDefault('/Seat/LeavingSeat?reservationId=' + selectedReservationId,
            (data) => {
                setLeaving(false);

                fetchDefault('/Payment/GetCurrentSeatList',
                    (data) => {
                        if (data && data.length > 0) {
                            setUseTableList(data);
                        } else {
                            setUseTableList();
                        }
                    }
                );
            }
        );
    };

    const cancelReserveOpen = (id) => {
        fetchDefault('/Payment/GetCancelReservationMoney?id=' + id,
            (data) => {
                setRefundMoney(data.refundMoney);
                setRefundTime(data.refundTime);
                setCancelReserveId(id);
                setCancelReserveDialog(true);
            }
        );
    };

    const cancelReserve = () => {

        fetchDefault('/Payment/CancelReservation?id=' + cancelReserveId,
            (data) => {
                setCancelReserveDialog(false);
                //내가 예약한 자리 목록
                fetchDefault('/Payment/GetReserveSeatList',
                    (data) => {
                        setReserveList(data);
                    }
                );
            }
        );
    }

    useEffect(() => {

        //var loginId = Cookies.get("LoginId");
        //if (loginId == null || loginId.length == 0 || loginId === undefined) {
        //        window.location.assign("/display/connected");
        //}

        //로그인 확인
        //fetchDefault('/User/IsLogin',
        //    (data) => {

                //내 정보
                fetchDefault('/User/GetMemberInfo',
                    (data) => {
                        if (data) {
                            setMyMoney(Math.floor(data.point));
                            setPrepaid(data.prepaidTime);
                        }
                    }
                );

                //월정액
                fetchDefault('/Payment/GetCurrentMonthly',
                    (data) => {
                        if (data && data.endDateTime) {
                            setCurrentMonthly(data.endDateTime.substring(0, 16));
                        }
                    }
                );

                //월정액 목록
                fetchDefault('/Payment/GetMonthlyList',
                    (data) => {
                        setMonthlyList(data);
                    }
                );


                //내 예약 정보
                fetchDefault('/Payment/GetCurrentSeatList',
                    (data) => {
                        if (data && data.length > 0) {
                            setUseTableList(data);
                        } else {
                            setUseTableList();
                        }
                    }
                );

                //내 사물함 정보
                fetchDefault('/Cabinet/GetCurrentCabinetList',
                    (data) => {
                        if (data && data.length > 0) {
                            setUseCabinetList(data);
                        } else {
                            setUseCabinetList();
                        }
                    }
                );

                //내가 예약한 자리 목록
                fetchDefault('/Payment/GetReserveSeatList',
                    (data) => {
                        if (data) {
                            setReserveList(data);
                        }
                    }
                );

            //},
            //(error) => {
            //    window.location.assign('/display/connected');
            //}
        //);

        //페이지 타임아웃

        const pageTimeout = setTimeout(() => {
            if (window.location.hostname == '192.168.0.2') {
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });

                window.location.assign('/display/connected');
            }
        }, 180000);

        return () => {
            clearTimeout(pageTimeout);
        }
    }, []);

    return (
        <div className={classes.root}>

            {/*
            <Tooltip title="연회원입니다." aria-label="add">
                <Fab color="secondary" className={classes.membershipAbsolute}>
                    Member
                </Fab>
            </Tooltip>
            */}

            <Grid container spacing={1}>
                {!useTableList ? (
                    
                    <Grid item xs={12} style={{ marginTop: -25 }}>
                        <Paper className={classes.paper} style={{ background: "red" }}>
                            <CheckCircleIcon style={{ color: "white", marginRight: 5 }} />

                            <font color="white">
                                이용중인 자리가 없습니다.
                            </font>
                            <Button className={classes.noticeButton} variant="outlined" component={Link} to="/occupySeat">
                                자리 이용하기
                            </Button>
                        </Paper>
                    </Grid>

                ) : (
                        <Grid item xs={12} style={{ marginTop: -18 }}>
                            <Grid item xs={12} style={{ marginTop: -30 }}>
                                  <Chip
                                        icon={<FaceIcon />}
                                        label="이용 시간이 종료되면 꼭 책상을 깨끗이 비워주세요~"
                                    />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 4 }}>
                                {useTableList.map(d => (
                                    <Paper className={classes.paper} style={{ background: "green" }}>
                                        <CheckCircleIcon style={{ color: "white", marginRight: 3 }} />

                                        <font color="white">
                                            {d.tableName}자리 {d.formattedEndDateTime}까지 이용가능 ※ 다른 사람이 자리예약 시 연장이 불가능합니다. 미리 연장해주세요.
                                    </font>
                                        <Button className={classes.noticeButton} variant="outlined" onClick={() => setSeatMap(true)}>
                                            위치보기
                                        </Button>
                                        <Button className={classes.noticeButton} variant="outlined" component={Link} to={'/moveSeat/' + d.reservationId}>
                                            자리이동
                                        </Button>
                                        <Button className={classes.noticeButton} variant="outlined" component={Link} to={'/extendSeat/' + d.reservationId}>
                                            연장하기
                                        </Button>
                                        {d.useTimeMin <= 1440 ? (
                                            <Button className={classes.noticeButton} variant="outlined" onClick={() => leavingOpen(d.reservationId)}>
                                            퇴실하기
                                        </Button>
                                        ) : (<div></div>)}
                                    </Paper>
                                ))}
                            </Grid>
                        </Grid>
                )}


                {!useCabinetList ? (
                    <Grid item xs={12}></Grid>
                ) : (
                        <Grid item xs={12}>
                            {useCabinetList.map(d => (
                                <Paper className={classes.cabinetPaper} style={{ background: "orange" }}>
                                    <CheckCircleIcon style={{ color: "white", marginRight: 5 }} />

                                    <font color="white">
                                        사물함 비밀번호 : {d.password} (!!비밀번호 변경금지!!) {d.number}번 사물함 {d.formattedEndDateTime}까지 이용가능 ※ 이용기간이 만료된 후 분실된 물품은 책임지지 않습니다. 미리 연장해주세요.
                                    </font>
                                    <Button className={classes.noticeButton} variant="outlined" component={Link} to={'/cabinetUseExtend/' + d.cabinetUseId}>
                                        연장하기
                                    </Button>
                                </Paper>
                            ))}
                        </Grid>
                    )}


                {reserveList ? (
                    <Grid item xs={12}>
                        {reserveList.map(seat => (
                            <Card style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="body1">
                                        자리 : {seat.tableName}
                                    </Typography>
                                    <Typography variant="body1">
                                        시작 : {seat.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        종료 : {seat.endDateTime}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small" onClick={() => cancelReserveOpen(seat.id)}>
                                        예약 취소하기
                                    </Button>
                                </CardActions>
                            </Card>
                        ))}
                    </Grid>
                ) : (<Grid></Grid>)}

                <Grid item xs={12}>
                    <Typography variant="h6">
                        카페 자리 이용하기
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button component={Link} to="/occupySeat" variant="outlined" color="primary" className={classes.menuButton}>
                        개인석 이용
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/reserveSeat">
                        개인석 예약
                    </Button>
                    {/*

                    */}

                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/reserveRoom">
                        스터디룸 예약
                    </Button>

                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        카페 더 저렴하게 이용하기
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/prepaid">
                        시간정액권
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/monthly">
                        월정액
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/fixedSeat">
                        지정석
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/chargeMoney">
                        잔액충전
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        카페 시설 이용하기
                    </Typography>
                </Grid>
                <Grid item xs={12}>


                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/cabinetUse">
                        사물함 이용
                    </Button>

                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/printerUse">
                        프린터 이용
                    </Button>

                    {/*
                    <Button variant="outlined" onClick={() => handleClick()} className={classes.menuButton}>
                        대여물품 안내
                        (준비중)
                    </Button>
                    */}

                    <Button variant="outlined" onClick={() => setWifi(true)} className={classes.menuButton}>
                       와이파이 안내
                    </Button>


                    <Button variant="outlined" onClick={() => setRestroom(true)} className={classes.menuButton}>
                       화장실 안내
                    </Button>


                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        고객센터
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {/*
                    <Button variant="outlined" onClick={() => handleClick()} className={classes.menuButton}>
                        이용내역 확인
                        (준비중)
                    </Button>
                    */}
                    <Button variant="outlined" onClick={() => setContact(true)} className={classes.menuButton}>
                        문의하기
                    </Button>
                    <Button variant="outlined" onClick={() => setRefund(true)} className={classes.menuButton}>
                        환불규정
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/history">
                        이용내역
                    </Button>
                    <Button variant="outlined" className={classes.menuButton} component={Link} to="/smsAgreement">
                        문자알림
                    </Button>
                </Grid>
                <Grid item xs={12} onClick={() => {
                    setClickCount(clickCount + 1); 
                    if (clickCount > 5)
                    {
                        setClickCount(0);

                        fetchDefault('Payment/GetLastBankTransferOrder',
                            (data) => {
                                if (data.order == null) {
                                    alert('입금완료를 누르지 않았습니다.');
                                } else {
                                    fetchDefault(decodeURIComponent(data.order),
                                        (result) => {
                                            alert(decodeURIComponent(data.order) +  '\n\n' + decodeURIComponent(JSON.stringify(result)));
                                        });
                                }

                            },
                            (error) => {
                                alert('error');
                            }
                        );
                    }
                }}>
                    <Typography variant="h6">
                        공지사항
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <List>
                        <ListItem button>
                            <ListItemText primary="홈페이지 예약" secondary="홈페이지 [ http://www.슷스터디신곡.com ] 에서도 자리예약이 가능합니다." />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="5% 추가 충전" secondary="계차이체로 10,000원 이상 잔액 충전 시 5% 금액이 추가 충전됩니다." />
                        </ListItem>
                        <Divider />
                    </List>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        내 정보
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        id="currentMonthly"
                        label="내 잔액"
                        readonly
                        className={classes.currentPrepaidTime}
                        value={myMoney + '원'}
                    />
                </Grid>

                {myPrepaid > 0 ? (
                    <Grid item xs={12}>
                        <TextField
                            id="currentTime"
                            label="정액권 남은시간"
                            readonly
                            className={classes.currentPrepaidTime}
                            value={Math.floor(myPrepaid/60) + '시간' + myPrepaid%60 + '분'}
                        />
                    </Grid>

                ) : (<Grid item xs = { 12 }></Grid>)}

                {currentMonthly ? (
                    <Grid item xs={12}>
                        <TextField
                            id="currentMonthly"
                            label="월정액 종료날짜"
                            readonly
                            className={classes.DateTextField}
                            type="datetime-local"
                            value={currentMonthly}
                        />
                    </Grid>
                ) : (<Grid item xs={12}></Grid>)}


                {monthlyList ? (
                    <Grid item xs={12}>
                        {monthlyList.map(monthly => (
                            <Card style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="body1">
                                        월정액 시작 : {monthly.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        월정액 종료 : {monthly.endDateTime}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </Grid>
                ) : (<Grid></Grid>)}

            </Grid>

            <div>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    key={'bottom','right'}
                    open={open}
                    onClose={handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">해당 기능은 준비중입니다. 곧 이용하실 수 있습니다. 관리자 문의 : 010-3849-0843</span>}
                    autoHideDuration={6000}
                />
            </div>

            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatMap}
                onClose={()=>{setSeatMap(false)}}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                        <img alt="loading..." src={require('../images/seats_v1.0.png')} style={{ width: 700 }} />
             
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={()=>{setSeatMap(false)}}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={wifi}
                onClose={() => { setWifi(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent align='center' style={{ marginLeft: 30, marginRight: 30 }}>
                    <img alt="loading..." src={require('../images/wifi.png')} style={{ width: 150, margin:20 }} />

                    <paper style={{margin:5}}>
                            <Typography variant="h5">
                                ID : study2G
                            <Typography variant="h5">
                            </Typography>
                                PW : study474
                            </Typography>
                    </paper>
                    <Divider />
                    <paper style={{ margin: 5 }}>
                        <Typography variant="h5">
                            ID : study5G
                            <Typography variant="h5">
                            </Typography>
                            PW : study474
                            </Typography>
                    </paper>
                    <Divider />
                    <paper style={{ margin: 5 }}>
                        <Typography variant="h5">
                            ID : study5G_2
                            <Typography variant="h5">
                            </Typography>
                            PW : study474
                            </Typography>
                    </paper>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { setWifi(false) }}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={restroom}
                onClose={() => { setRestroom(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent align='center'>
                    <img alt="loading..." src={require('../images/restroom.png')} style={{ width: 150, margin: 20 }} />


                    
                    {/*<paper style={{ margin: 5 }}>*/}
                    {/*    <Typography variant="h5">*/}
                    {/*        카페 외부 화장실 비밀번호 2020**/}
                    {/*    </Typography>*/}
                    {/*</paper>*/}


                    {/*<paper style={{ margin: 5 }}>*/}
                    {/*    <Typography variant="h6">*/}
                    {/*        화장실 위치 : 출입구 오른쪽 스시웨이 식당 옆*/}
                    {/*    </Typography>*/}
                    {/*</paper>*/}

                    {/*<paper style={{ margin: 5 }}>*/}
                    {/*    <Typography variant="h6">*/}
                    {/*        화장실 비밀번호 : 남자 2020* / 여자 5050**/}
                    {/*    </Typography>*/}
                    {/*</paper>*/}


                     


                    {/*

                    <paper style={{ margin: 5 }}>
                        <Typography variant="h5">
                            화장실 비밀번호 2020*
                        </Typography>
                    </paper>



                    */}

                    <paper style={{ margin: 5 }}>
                        <Typography variant="h5">
                            - 남녀공용 화장실 -
                        </Typography>
                    </paper>

                    <paper style={{ margin: 5 }}>

                        <Typography variant="h6">
                            계단 반층 아래 화장실 비밀번호 2020*
                        </Typography>

                    </paper>

                    <Divider />

                    <paper style={{ margin: 5 }}>
                        <Typography variant="h5">
                            - 여자 화장실 -
                        </Typography>
                    </paper>

                    <paper style={{ margin: 5 }}>
                        <Typography variant="h6">
                            카페 내부에 있습니다.
                        </Typography>
                    </paper>


                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { setRestroom(false) }}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={contact}
                onClose={() => { setContact(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent align='center'>
                    <img alt="loading..." src={require('../images/info.png')} style={{ width: 150, margin: 20 }} />

                    <paper style={{ margin: 2 }}>
                        <Typography variant="h6">
                             [신곡점]을 문자 앞에 붙여서 [010-3849-0843]으로 문자 문의 부탁드립니다. 최대한 빨리 안내드리겠습니다.
                        </Typography>
                    </paper>
                    {/*
                    <paper style={{ margin: 2 }}>
                        <Typography variant="h6">
                            <ContactMailIcon /> 010-3849-0843
                        </Typography>
                    </paper>
                    <Divider />
                    <paper style={{ margin: 2 }}>
                        <Typography variant="h6">
                            카카오톡
                        </Typography>
                    </paper>
                    <paper style={{ margin: 2 }}>
                        <Typography variant="h6">
                            <img alt="loading..." src={require('../images/kakaotalk.png')} style={{ width: 30 }} /> 검색 : 슷카페
                        </Typography>
                    </paper>
                    */}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { setContact(false) }}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={refund}
                onClose={() => { setRefund(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent align='left'>
                    <paper style={{ margin: 2 }}>
                        <Typography variant="h5" style={{ marginBottom: 20 }}>
                            환불금 안내
                        </Typography>
                        <Typography variant="h6" style={{ marginBottom: 8 }}>
                            1. 월정액, 지정석
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 15 }}>
                            결제금액 - (12,000원 x 이용일수)
                        </Typography>
                        <Typography variant="h6" style={{ marginBottom: 8 }}>
                            2. 시간정액권
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 15 }}>
                            결제금액 - (수수료 20% 차감) - (960원 x 사용시간)
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 15 }}>
                            (결제일 7일 이내만 환불가능)
                        </Typography>
                        <Typography variant="h6" style={{ marginBottom: 8 }}>
                            3. 사물함
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 15 }}>
                            환불 불가
                        </Typography>
                        <Typography variant="h6" style={{ marginBottom: 8 }}>
                            4. 잔액
                        </Typography>
                        <Typography variant="body1">
                            계좌이체, 현금 : 현재잔액 - 추가 지급된 금액
                        </Typography>
                        <Typography variant="body1">
                            신용카드 : 현재잔액 - (수수료 10% 차감)
                        </Typography>
                        <Typography variant="body2" style={{ marginTop: 20 }}>
                            ※ 환불 관련 법률 조항 : 학원법 법률 시행령 제18조 제3항
                        </Typography>
                        <Typography variant="body2" style={{ marginTop: 8 }}>
                            ※ 산출 기준 : 하루 이용 금액 12,000원 / 한 시간 이용 금액 : 960원
                        </Typography>
                    </paper>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { setRefund(false) }}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={leaving}
                onClose={() => setLeaving(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        {refundMoney}원이 잔액으로 충전됩니다.
                    </Typography>

                    {refundTime > 0 ? (
                        <Typography variant="h6" color="textPrimary">
                            {refundTime}분이 저장됩니다.
                        </Typography>
                    ) : (<div></div>)}

                    <Typography variant="h6" color="textPrimary">
                        퇴실하시겠습니까?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => leavingSeat()}>
                        <Typography variant="h6">
                            퇴실
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={() => setLeaving(false)}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={cancelReserveDialog}
                onClose={() => setCancelReserveDialog(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        {refundMoney}원이 잔액으로 충전됩니다.
                    </Typography>

                    {refundTime > 0 ? (
                        <Typography variant="h6" color="textPrimary">
                            {refundTime}분이 저장됩니다.
                        </Typography>
                    ) : (<div></div>)}

                    <Typography variant="h6" color="textPrimary">
                        예약취소 하시겠습니까?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => cancelReserve()}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={() => setCancelReserveDialog(false)}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
    
}
 


// WEBPACK FOOTER //
// ./src/components/Home.js